var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompareTheMarketLogoinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 110,
  height: 30,
  viewBox: "0 0 146 40",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#CompareTheMarketLogo_inline_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.042 15.953a6.533 6.533 0 0 1-1.623.435c-.517.064-1.058.096-1.624.096-1.316 0-2.403-.248-3.259-.743a4.64 4.64 0 0 1-1.91-2.049c-.417-.87-.626-1.85-.626-2.94 0-1.074.198-2.044.594-2.907a4.873 4.873 0 0 1 1.762-2.07c.778-.517 1.74-.775 2.887-.775 1.316 0 2.338.348 3.067 1.04.728.694 1.093 1.649 1.093 2.866-.283.071-.722.106-1.316.106-.24 0-.482-.01-.722-.031a5.407 5.407 0 0 1-.573-.075c-.057-.453-.201-.81-.435-1.072-.233-.261-.612-.392-1.135-.392-.68 0-1.21.286-1.593.859-.381.573-.572 1.39-.572 2.452 0 1.146.268 1.98.806 2.504s1.288.786 2.25.786c.467 0 .85-.025 1.146-.075.297-.05.693-.159 1.189-.329.17.283.31.612.424.987.114.376.17.818.17 1.327Zm11.33-8.093a4.652 4.652 0 0 0-1.741-2.07c-.779-.51-1.77-.764-2.972-.764-1.175 0-2.154.255-2.94.764a4.628 4.628 0 0 0-1.75 2.07c-.383.87-.574 1.85-.574 2.94 0 1.075.191 2.044.573 2.908a4.573 4.573 0 0 0 1.751 2.048c.786.502 1.765.753 2.94.753 1.203 0 2.193-.251 2.972-.753a4.596 4.596 0 0 0 1.74-2.048c.382-.864.574-1.833.574-2.908 0-1.09-.192-2.07-.574-2.94Zm-3.004 5.476c-.347.587-.916.88-1.709.88-.778 0-1.34-.293-1.687-.88s-.52-1.433-.52-2.536c0-1.104.173-1.95.52-2.537.346-.587.909-.881 1.687-.881.793 0 1.362.294 1.71.881.346.587.519 1.433.519 2.537 0 1.103-.173 1.95-.52 2.536Zm8.12 2.893a9.148 9.148 0 0 1-1.507.128c-.495 0-.997-.043-1.507-.128V5.255a5.81 5.81 0 0 1 1.253-.127c.24 0 .452.01.636.032.184.021.375.053.573.095.085.142.156.382.212.722.057.339.1.608.128.806.226-.424.594-.828 1.104-1.21C71.89 5.191 72.533 5 73.31 5c1.698 0 2.795.651 3.29 1.953a4.23 4.23 0 0 1 1.2-1.37C78.316 5.195 78.97 5 79.763 5c1.245 0 2.162.343 2.749 1.03.587.686.88 1.758.88 3.215v6.984a9.148 9.148 0 0 1-1.507.127c-.495 0-.997-.042-1.507-.127V10.03c0-.764-.095-1.351-.286-1.761-.191-.411-.577-.616-1.157-.616-.312 0-.62.068-.924.202-.304.134-.559.393-.764.774-.205.382-.307.942-.307 1.677v5.922a9.148 9.148 0 0 1-1.507.128c-.496 0-.998-.043-1.507-.128v-6.198c0-.764-.096-1.351-.287-1.761-.19-.411-.576-.616-1.157-.616-.326 0-.64.071-.944.213-.305.141-.556.414-.754.817-.198.403-.297 1-.297 1.793v5.752Zm24.217-8.787c-.382-.821-.902-1.433-1.56-1.836C92.487 5.202 91.747 5 90.927 5c-.793 0-1.444.191-1.953.574-.51.382-.892.799-1.147 1.252a10.146 10.146 0 0 0-.201-1.125 1.84 1.84 0 0 0-.16-.446 5.756 5.756 0 0 0-1.21-.127c-.24 0-.456.007-.647.021a4.343 4.343 0 0 0-.584.085v14.912c.269.042.527.07.775.085a12.97 12.97 0 0 0 1.465 0 7.95 7.95 0 0 0 .775-.085v-3.768c.353.07.785.106 1.295.106 1.868 0 3.325-.53 4.372-1.592 1.047-1.061 1.57-2.505 1.57-4.33 0-1.26-.19-2.3-.572-3.12Zm-3.333 5.773c-.467.566-1.139.85-2.016.85-.467 0-.906-.057-1.316-.17v-3.737c0-.707.148-1.312.446-1.814.297-.502.799-.754 1.507-.754.764 0 1.301.29 1.613.87.31.58.467 1.31.467 2.187 0 1.146-.234 2.002-.7 2.568Zm12.772-7.153C103.316 5.354 102.166 5 100.695 5c-.538 0-1.118.05-1.741.149-.623.099-1.245.255-1.868.467 0 .453.05.842.149 1.168.099.325.247.672.445 1.039.878-.297 1.691-.445 2.441-.445.708 0 1.274.103 1.698.308.425.205.637.647.637 1.326v.255a15.67 15.67 0 0 0-1.358-.064 8.17 8.17 0 0 0-1.698.18 5.128 5.128 0 0 0-1.55.595 3.236 3.236 0 0 0-1.125 1.104c-.283.46-.424 1.03-.424 1.709 0 .905.205 1.627.615 2.165.41.538.984.926 1.72 1.167.735.24 1.584.36 2.547.36.891 0 1.691-.07 2.398-.211.708-.142 1.309-.29 1.805-.446V9.458c0-1.556-.414-2.688-1.242-3.396ZM102.456 14c-.156.029-.339.06-.551.096a3.865 3.865 0 0 1-.637.053c-.255 0-.549-.025-.881-.074a1.803 1.803 0 0 1-.881-.382c-.255-.205-.382-.549-.382-1.03 0-.552.202-.951.605-1.2.403-.247.951-.37 1.645-.37.339 0 .7.035 1.082.106V14Zm7.807 2.25c-.255.043-.509.07-.764.085a13.515 13.515 0 0 1-1.475 0 7.782 7.782 0 0 1-.775-.085V5.255a5.756 5.756 0 0 1 1.231-.127c.212 0 .421.014.626.042.205.029.407.064.605.107.085.141.156.386.212.732.057.347.099.619.128.817a5.46 5.46 0 0 1 1.125-1.167c.453-.354.983-.531 1.592-.531.198 0 .382.008.552.021.17.014.325.035.467.064.028.141.049.304.063.488.014.184.021.375.021.573 0 .24-.01.502-.032.785-.021.283-.06.552-.117.807a2.95 2.95 0 0 0-.52-.043h-.35c-.241 0-.51.029-.807.085a2.08 2.08 0 0 0-.849.382c-.269.199-.492.513-.668.945-.177.432-.266 1.03-.266 1.793v5.222h.001Zm12.766-2.695a8.026 8.026 0 0 1-2.823.53c-.821 0-1.489-.162-2.006-.488-.517-.325-.838-.85-.966-1.57a14.43 14.43 0 0 0 2.123.148c.892 0 1.709-.117 2.452-.35.743-.234 1.337-.609 1.783-1.125.446-.517.669-1.185.669-2.006 0-1.118-.397-2.013-1.189-2.685-.793-.673-1.883-1.009-3.269-1.009-1.203 0-2.222.258-3.057.775a4.99 4.99 0 0 0-1.9 2.112c-.431.892-.647 1.91-.647 3.057 0 1.047.198 1.992.594 2.834.396.842 1.019 1.503 1.868 1.984.849.48 1.96.722 3.333.722.622 0 1.245-.053 1.868-.16a9.247 9.247 0 0 0 1.762-.477 5.27 5.27 0 0 0-.595-2.292Zm-4.977-5.594a2.453 2.453 0 0 1 1.708-.668c.524 0 .934.127 1.231.382.297.255.447.587.447.998 0 .382-.114.682-.34.902-.227.22-.517.375-.871.467a4.37 4.37 0 0 1-1.103.138c-.751 0-1.394-.035-1.932-.106.085-.963.371-1.667.86-2.113Zm27.202 15.743h-.486l-.854 2.497h-.004l-.855-2.497h-.5a31.318 31.318 0 0 0-.234 3.15h.379c.014-.974.061-1.96.121-2.66h.004l.896 2.66h.296l.89-2.66h.006c.084.64.158 1.686.177 2.66h.411a34.257 34.257 0 0 0-.247-3.15Zm-5.443 0v.307h.817v2.843h.387V24.01h.823v-.307h-2.027ZM77.839 34.678a9.144 9.144 0 0 1-1.507.127c-.495 0-.997-.042-1.507-.127V23.704a5.81 5.81 0 0 1 1.253-.127c.24 0 .453.01.637.031.184.022.374.053.573.096.085.141.155.382.212.721.056.34.099.609.127.807.226-.425.595-.828 1.104-1.21.51-.382 1.154-.573 1.932-.573 1.699 0 2.794.65 3.29 1.952a4.23 4.23 0 0 1 1.199-1.369c.516-.389 1.171-.583 1.964-.583 1.245 0 2.161.343 2.749 1.03.587.686.88 1.758.88 3.215v6.983a9.144 9.144 0 0 1-1.506.128c-.496 0-.998-.043-1.507-.128V28.48c0-.764-.096-1.351-.287-1.762-.19-.41-.576-.615-1.157-.615-.311 0-.619.067-.923.201-.305.135-.56.393-.764.775-.206.382-.308.941-.308 1.677v5.922a9.144 9.144 0 0 1-1.508.127c-.495 0-.997-.042-1.507-.127V28.48c0-.764-.095-1.351-.286-1.762-.191-.41-.577-.615-1.157-.615-.326 0-.64.07-.945.212-.304.142-.555.414-.753.817-.199.404-.298 1.001-.298 1.794v5.752Zm22.377-10.167c-.828-.708-1.978-1.061-3.45-1.061-.537 0-1.117.05-1.74.148a11.23 11.23 0 0 0-1.868.467c0 .453.05.842.149 1.168.099.325.247.672.446 1.04.877-.298 1.69-.446 2.44-.446.708 0 1.274.103 1.699.308.424.205.637.647.637 1.326v.255a15.69 15.69 0 0 0-1.359-.064c-.566 0-1.132.06-1.698.18a5.129 5.129 0 0 0-1.55.595 3.234 3.234 0 0 0-1.124 1.104c-.284.46-.425 1.03-.425 1.709 0 .905.205 1.627.615 2.165.41.538.984.926 1.72 1.167.735.24 1.584.36 2.547.36.891 0 1.69-.07 2.398-.211a17.65 17.65 0 0 0 1.805-.446v-6.368c0-1.556-.414-2.688-1.242-3.396Zm-1.687 7.938c-.156.029-.34.06-.552.096a3.86 3.86 0 0 1-.637.053c-.255 0-.549-.025-.88-.074a1.804 1.804 0 0 1-.882-.382c-.255-.205-.382-.549-.382-1.03 0-.552.201-.951.605-1.2.403-.247.951-.37 1.645-.37.34 0 .7.035 1.083.106v2.801Zm7.731 2.25c-.254.043-.509.07-.764.085a13.542 13.542 0 0 1-1.475 0 7.782 7.782 0 0 1-.775-.085V23.704a5.756 5.756 0 0 1 1.231-.127c.213 0 .421.014.626.043.205.028.407.063.605.106.085.141.156.386.212.732.057.347.099.62.128.817a5.458 5.458 0 0 1 1.125-1.167c.452-.354.983-.53 1.592-.53.198 0 .382.007.551.02.17.014.326.036.467.064.028.141.05.304.064.488.014.184.021.375.021.573 0 .24-.01.502-.031.785a5.87 5.87 0 0 1-.117.807 2.95 2.95 0 0 0-.52-.043h-.35c-.241 0-.51.029-.807.085a2.08 2.08 0 0 0-.849.382c-.269.199-.492.513-.668.945-.177.432-.266 1.03-.266 1.793V34.7Zm4.943-.021V20.562a8.771 8.771 0 0 1 2.993 0v8.257l3.121-5.115a11.123 11.123 0 0 1 2.547-.096c.297.021.573.053.827.095l-3.396 5.116 3.864 5.858c-.284.043-.584.075-.902.096a13.47 13.47 0 0 1-.881.031c-.51 0-1.04-.042-1.592-.127l-3.588-5.646v5.646a8.646 8.646 0 0 1-1.507.127 8.66 8.66 0 0 1-1.486-.126Zm18.532-2.674a8.026 8.026 0 0 1-2.823.53c-.821 0-1.49-.162-2.006-.488-.517-.325-.839-.85-.966-1.57a14.42 14.42 0 0 0 2.123.148c.891 0 1.708-.117 2.451-.35.743-.234 1.338-.609 1.783-1.125.446-.517.669-1.185.669-2.006 0-1.118-.396-2.013-1.189-2.685-.792-.672-1.882-1.008-3.269-1.008-1.203 0-2.221.258-3.056.774a4.991 4.991 0 0 0-1.9 2.112c-.432.892-.648 1.91-.648 3.057 0 1.047.199 1.992.595 2.834.396.842 1.019 1.503 1.868 1.984.849.48 1.96.722 3.332.722.623 0 1.245-.053 1.868-.16a9.247 9.247 0 0 0 1.762-.477 5.223 5.223 0 0 0-.191-1.274 4.968 4.968 0 0 0-.403-1.018Zm-4.978-5.594a2.457 2.457 0 0 1 1.709-.668c.523 0 .934.127 1.231.382.297.255.446.587.446.998 0 .382-.114.682-.34.902a1.91 1.91 0 0 1-.87.467 4.371 4.371 0 0 1-1.104.138c-.75 0-1.394-.035-1.931-.106.085-.963.371-1.667.859-2.113Zm6.848-.414-.106-.424 3.969-5.073h.488v3.205h2.568a4.985 4.985 0 0 1 .106 1.103 5.838 5.838 0 0 1-.106 1.189h-2.568v4.309c0 .863.138 1.43.414 1.698.276.269.676.403 1.199.403.212 0 .421-.017.626-.053l.542-.095c.098.269.169.548.212.838a5.486 5.486 0 0 1 .053 1.167 4.131 4.131 0 0 1-.032.308c-.325.071-.654.128-.986.17a8.128 8.128 0 0 1-1.03.063c-1.288 0-2.271-.3-2.95-.902-.679-.601-1.019-1.581-1.019-2.94v-4.967h-1.38v.001Zm-83.253-1.133v7.18c0 .476.08.83.238 1.06a1.1 1.1 0 0 0 .616.454c.253.072.509.108.769.108.519 0 .958-.065 1.318-.195.058.188.105.382.142.584.035.202.06.41.075.627a6.528 6.528 0 0 1-1.816.239c-.821 0-1.489-.22-2.001-.66-.512-.44-.767-1.157-.767-2.153v-7.244h-1.882a2.047 2.047 0 0 1-.032-.281 4.984 4.984 0 0 1 0-.67c.007-.101.017-.188.032-.26h1.882v-2.076l1.34-1.319h.086v3.395h2.985c.015.072.025.159.033.26a5.693 5.693 0 0 1 0 .67 2.17 2.17 0 0 1-.033.281H48.35Zm6.5 9.853a7.037 7.037 0 0 1-.713.044 7.5 7.5 0 0 1-.714-.044V20.279c.086-.014.205-.025.357-.032.15-.007.27-.012.357-.012.072 0 .187.005.345.012.159.007.28.018.367.032v5.376c.202-.36.469-.71.8-1.049.333-.338.74-.62 1.222-.844a3.846 3.846 0 0 1 1.633-.335c1.268 0 2.202.378 2.801 1.136.598.757.898 1.82.898 3.19v6.963a7.07 7.07 0 0 1-.714.044 7.466 7.466 0 0 1-.714-.044v-6.531c0-1.225-.202-2.104-.606-2.638-.403-.534-.987-.8-1.751-.8-1.01 0-1.857.371-2.541 1.113-.686.743-1.028 1.842-1.028 3.298v5.558Zm14.398-1.06c-2.55 0-3.877-1.31-3.979-3.936.462.058.938.113 1.428.163s1.001.075 1.535.075c1.442 0 2.596-.267 3.46-.8.866-.533 1.298-1.384 1.298-2.551 0-1.025-.357-1.817-1.07-2.38-.714-.562-1.67-.843-2.866-.843-1.009 0-1.913.231-2.714.692-.8.462-1.428 1.136-1.882 2.022-.453.887-.68 1.972-.68 3.255 0 1.773.467 3.146 1.405 4.12.937.973 2.278 1.46 4.022 1.46.549 0 1.11-.051 1.688-.152.576-.101 1.066-.245 1.47-.432a3.74 3.74 0 0 0-.26-1.211c-.995.345-1.946.519-2.855.519Zm-2.81-7.99c.691-.685 1.564-1.028 2.616-1.028.851 0 1.482.188 1.892.562.41.376.616.866.616 1.472 0 .533-.147.95-.442 1.254-.297.302-.696.516-1.201.638a7.23 7.23 0 0 1-1.708.183 18.85 18.85 0 0 1-1.557-.065 22.672 22.672 0 0 1-1.363-.15c.072-1.226.454-2.18 1.146-2.866Z",
  fill: "#0028D7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 40.009c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z",
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.275 11.62c-.628.78-.974.749-.974.749s-.364.995-1.009 1.773c-.325.392-.79.915-1.25 1.407-.484.517-.961.999-1.267 1.262-.313.27-1.182 1.283-1.962 2.386-.665.943-1.264 1.952-1.395 2.622-.026.135.01.28.107.378.127.128.297.13.31.13-.043.032-1.928 1.457-1.599 3.857.183 1.111.426 1.237.426 1.237s-2.895-.586-5.283.806c-1.948-.832-4.116-1.277-5.798-1.515-1.681-.238-2.877-.266-2.877-.266-.13-.51-.44-2.014-2.188-3.437-1.585-1.29-4.173-4.995-2.544-9.427 1.63-4.432 5.879-6.45 7.656-7.051 2.25-.762 4.86-1.132 5.764-1.488 0 0 .09-.034.225-.088h.002l.003-.001c.354-.14 1.012-.403 1.224-.528.296-.173.48-.06.588.27.108.33 1.874 2.737 3.858 3.016l.013.002c1.99.27 5.046-.239 5.38-.263.334-.023 1.707-.2 2.526.799.819.998.693 2.588.064 3.37Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.379 28.227c2.387-1.392 5.283-.806 5.283-.806s-.243-.126-.426-1.237c-.329-2.4 1.556-3.825 1.598-3.857a.468.468 0 0 1-.309-.13.423.423 0 0 1-.107-.379c.13-.67.73-1.678 1.395-2.621l.037-.052-.836-.7a2.203 2.203 0 0 0-1.36-.504 2.096 2.096 0 0 0-1.718.897c-.74.92-1.684 1.67-2.824 2.039-.037.012-.071-.024-.06-.06l.19-.567c-1.245.934-2.635 1.953-4.249 1.971a.05.05 0 0 1-.034-.083c.279-.279.55-.56.773-.884-1.112.484-2.276 1.02-3.516.807-.046-.008-.042-.067-.012-.088.325-.24.633-.495.92-.773-4.413.437-8.758-.784-8.173-7.558l-.001.003-.06.172c-1.455 4.327 1.069 7.925 2.626 9.192 1.748 1.422 2.058 2.926 2.188 3.437 0 0 1.196.028 2.877.266 1.682.238 3.85.683 5.798 1.515Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.082 13.585s-1.05-.003-1.691-.056-2.33-.24-2.981-.13c-.651.11-1.286.19-1.98.873-.696.684-2.218 2.112-2.242 2.466-.025.353 1.488 4.914 7.629 2.45a.046.046 0 0 1 .004-.002c.777-1.099 1.642-2.105 1.954-2.374.306-.263.784-.745 1.267-1.262.46-.492.925-1.015 1.25-1.407.645-.778 1.008-1.773 1.008-1.773-.182.124-1.845 1.215-4.218 1.215Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.45 15.52c-.38-.505-.646-1.188-.56-1.828-.209.114-.412.238-.623.348-.03.015-.076-.003-.073-.042.046-.625.367-1.14.568-1.716a6.935 6.935 0 0 0-.823.184c-.039.01-.078-.036-.055-.072.657-1.001 1.78-1.659 2.9-2.045.081-.156.12-.337.1-.433l-.003-.014c-.316-1.236-2.895-.187-4.107 1.251-1.145 1.36-1.443 3.169-1.098 4.687.358 1.57 1.403 2.83 2.912 2.957.335.029.672.011.998-.062 0 0 .508-.15.731-.266.675-.353 1.131-1.2.871-2.053-.632-.236-1.293-.308-1.738-.897Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.643 8.024c.166-.001.331-.008.497-.037.043-.007.074.032.055.072-.44.915-.823 1.787-.657 2.826.069.43.218.897.462 1.292.034.015.067.03.103.042.785-3.362 7.036-1.296 8.2-4.506h-.005l-.005-.001c-1.985-.28-3.75-2.686-3.859-3.016-.108-.33-.293-.443-.588-.27-.212.125-.87.388-1.224.528h-.003l-.002.001c-1.25.623-2.335 1.827-2.974 3.07Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.503 7.444c-1.18.135-1.677 2.406-2.387 2.888 1.27-.407 2.887-.48 4.176-.905.167-1.51-.764-2.1-1.789-1.983Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.843 8.562c-.61.036-.937 1.152-1.312 1.44.74-.134 1.51-.242 2.216-.42.085-.736-.375-1.051-.904-1.02Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.211 8.25c-.819-.999-2.192-.822-2.526-.799a1.416 1.416 0 0 0-.053.005c-.062.079-.137.295-.16.412.047.056.25.185.4.234.173.057.241.15.337.309.067.11.099.234.146.353.02.052.043.098.07.142 1.019.334 2.464.494 2.308 1.648.142-.762.008-1.658-.522-2.304Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.695 29.917c-1.678-2.23-4.033-2.496-4.033-2.496s-2.895-.587-5.283.806c0 0 1.311.585 1.714 1.238.404.652.544 1.116.7 2.19.155 1.074.44 1.735.44 1.735 1.968 1.196 6.069 4.83 6.06 4.824l.025-.012a20.014 20.014 0 0 0 3.512-2.066c-.512-2.211-1.49-4.032-3.135-6.22Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.233 33.39c-5.944-3.617-11.018-3.858-11.325-3.869.068-1.566-.204-3.075-.204-3.075s4.78.116 8.675 1.781c0 0 1.311.586 1.714 1.238.404.652.544 1.116.7 2.19.155 1.074.44 1.735.44 1.735Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__j)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 40.01c2.959 0 5.767-.643 8.293-1.796.009.007-4.092-3.627-6.06-4.824-5.944-3.617-11.009-3.857-11.317-3.868h-.008c-.005.845-.46 5.243-1.519 7.44v.003A19.906 19.906 0 0 0 20 40.009Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__k)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.293 38.214c.009.007-4.092-3.627-6.06-4.824-5.944-3.617-11.018-3.858-11.325-3.869-.003.495-.16 2.21-.502 3.986 1.229.04 8.008.5 14.284 5.949a19.88 19.88 0 0 0 3.603-1.242Z",
  fill: "url(#CompareTheMarketLogo_inline_svg__l)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__a",
  x1: 9.01,
  y1: 24.196,
  x2: 32.114,
  y2: 6.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39261D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.659,
  stopColor: "#E0B585"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.751,
  stopColor: "#DDB283"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.825,
  stopColor: "#D3A87B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.893,
  stopColor: "#C2986F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.957,
  stopColor: "#AA815D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#966D4E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__b",
  x1: 22.544,
  y1: 14.211,
  x2: 9.763,
  y2: 25.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0B58B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.225,
  stopColor: "#A98565",
  stopOpacity: 0.374
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.479,
  stopColor: "#71543E",
  stopOpacity: 0.796
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.602,
  stopColor: "#5B412F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.623,
  stopColor: "#573D2D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802,
  stopColor: "#38241B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.902,
  stopColor: "#2C1A14"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.946,
  stopColor: "#20100C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#170906"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__d",
  x1: 7.933,
  y1: 13.545,
  x2: 14.896,
  y2: 14.627,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.096,
  stopColor: "#200D05",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.886,
  stopColor: "#200D05",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__e",
  x1: 15.755,
  y1: 8.896,
  x2: 23.861,
  y2: 7.402,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B331F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A321E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__f",
  x1: 19.116,
  y1: 8.881,
  x2: 23.311,
  y2: 8.881,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.001,
  stopColor: "#5A321E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.328,
  stopColor: "#432214",
  stopOpacity: 0.328
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  stopColor: "#2B1209",
  stopOpacity: 0.743
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#220C05"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__g",
  x1: 20.531,
  y1: 9.281,
  x2: 22.758,
  y2: 9.281,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#25130E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.117,
  stopColor: "#25130E",
  stopOpacity: 0.115
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#25130E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__h",
  x1: 29.262,
  y1: 6.976,
  x2: 35.366,
  y2: 10.371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.138,
  stopColor: "#502414",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#502414"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__i",
  x1: 22.874,
  y1: 34.24,
  x2: 28.665,
  y2: 29.877,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#FFB503"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.868,
  stopColor: "#FFD719"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__j",
  x1: 10.704,
  y1: 29.918,
  x2: 22.233,
  y2: 29.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#FFB503"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.868,
  stopColor: "#FFD719"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__k",
  x1: 9.216,
  y1: 35.796,
  x2: 27.537,
  y2: 33.092,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#641724"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.104,
  stopColor: "#711825"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.288,
  stopColor: "#941B26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.433,
  stopColor: "#B31E28"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CompareTheMarketLogo_inline_svg__l",
  x1: 10.705,
  y1: 35.536,
  x2: 27.531,
  y2: 33.052,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5B0D14"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.461,
  stopColor: "#94171F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.705,
  stopColor: "#AD1B24"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "CompareTheMarketLogo_inline_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(11.89746 -2.31554 1.67568 8.6098 31.696 10.301)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.208,
  stopColor: "#5B3622"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.451,
  stopColor: "#5D3824",
  stopOpacity: 0.692
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.582,
  stopColor: "#65402A",
  stopOpacity: 0.528
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.685,
  stopColor: "#734D35",
  stopOpacity: 0.397
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "#865F44",
  stopOpacity: 0.283
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.855,
  stopColor: "#9F7758",
  stopOpacity: 0.182
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.928,
  stopColor: "#BD946F",
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.995,
  stopColor: "#E1B68B",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999,
  stopColor: "#E3B88D",
  stopOpacity: 0
})))));
export default SvgCompareTheMarketLogoinline;